import { FaSpinner } from 'react-icons/fa'

const SuperSpinner = () => {

    return (
        <div className='loader-holder'>
            <FaSpinner size={60} />
        </div>
    )
}

export default SuperSpinner
